import type { TaskOccurrence } from '../../core/api/rtk/taskTemplatesApi';

export interface SearchableTaskRow {
  name?: string;
  raw?: TaskOccurrence | null;
  source?: { name?: string } | null;
}

/**
 * Every piece of a task row a person might type to find it again: what it is
 * called, how often it runs, its status and the group or sub-asset it hangs
 * off. Notes are included because that is where site-specific wording lands.
 */
const searchableText = (row: SearchableTaskRow): string =>
  [
    row.name,
    row.raw?.name,
    row.raw?.task?.name,
    row.raw?.task?.subTitle,
    row.raw?.task?.interval,
    row.raw?.type,
    row.raw?.priority,
    row.raw?.status,
    row.raw?.notes,
    row.source?.name,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

export const matchesTaskSearch = (row: SearchableTaskRow, term: string): boolean => {
  const needle = term.trim().toLowerCase();
  if (!needle) return true;
  return searchableText(row).includes(needle);
};

export function filterTaskRows<T extends SearchableTaskRow>(rows: T[], term: string): T[] {
  if (!term.trim()) return rows;
  return rows.filter((row) => matchesTaskSearch(row, term));
}
